import { DependenciesInjection } from "app/di/DependencyInjection";
import { CashFlowImpl } from "../data/CashFlowImpl";
import { ICashFlowRepository } from "../domain/repositories/ICashFlowRepository";
import { CashFlowUseCase } from "../domain/useCases/CashFlowUseCase";
import { CashFlowViewModel } from "../presentation/viewModel/CashFlowViewModel";
import { CashFlowToken } from "./CashFlowToken";

export class CashFlowInjection {
  static initInjection() {
    DependenciesInjection.register<ICashFlowRepository>(
      CashFlowToken.ICashFlowRepository,
      CashFlowImpl,
      "otherRepo",
    );
    DependenciesInjection.register<CashFlowUseCase>(
      CashFlowToken.CashFlowUseCase,
      CashFlowUseCase,
      "otherRepo",
    );
    DependenciesInjection.register<CashFlowViewModel>(
      CashFlowToken.CashFlowViewModel,
      CashFlowViewModel,
      "viewModel",
    );
  }

  static getRepo() {
    return DependenciesInjection.getRepo<ICashFlowRepository>(
      CashFlowToken.ICashFlowRepository,
    );
  }

  static getUseCase() {
    return DependenciesInjection.getRepo<CashFlowUseCase>(
      CashFlowToken.CashFlowUseCase,
    );
  }
}
